import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { addContactRole, removeContactRole } from 'bundles/apex/deals/form/store/deal/actions';

import Collection from 'bundles/apex/deals/form/fields/collection';
import ContactRole from './contact_role';

export function DealContacts({ addContactRole, deal, label, removeContactRole, required, role }) {
  const contactRoles = deal.contactRoles.filter(contactRole => contactRole.role === role && !contactRole._destroy);

  function clear() {
    removeContactRole(contactRoles[0]);
    addContactRole(role);
  }

  return (
    <Collection
      addLabel={`Add ${label}`}
      hasValue={!!contactRoles[0]?.contact}
      onAdd={() => addContactRole(role)}
      onClear={clear}
      onRemoveIndex={index => removeContactRole(contactRoles[index])}
    >
      {contactRoles.map((contactRole, i) => (
        <ContactRole
          contactRole={contactRole}
          key={contactRole.id || contactRole.localId}
          label={label}
          primary={!i}
          required={required}
        />
      ))}
    </Collection>
  );
}

DealContacts.propTypes = {
  addContactRole: PropTypes.func.isRequired,
  deal: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  removeContactRole: PropTypes.func.isRequired,
  required: PropTypes.bool,
  role: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
  addContactRole,
  removeContactRole,
};

export default connect(null, mapDispatchToProps)(DealContacts);
